import React from "react";
import IndexPage from "./legal"

const IndexPageRU = () => (
  <IndexPage i18n="ru"/>
);

export default IndexPageRU;
